import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 10px;\n  height: 40px;\n  min-width: 40px;\n  opacity: 0; /* opacity: 1 on collection Card hover*/\n  z-index: 1;\n\n  &:focus {\n    opacity: 1;\n  }\n  /* show on tablet down always*/\n  @media (max-width: ', ') {\n    opacity: 1;\n  }\n  ', '\n  ', '\n'], ['\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 10px;\n  height: 40px;\n  min-width: 40px;\n  opacity: 0; /* opacity: 1 on collection Card hover*/\n  z-index: 1;\n\n  &:focus {\n    opacity: 1;\n  }\n  /* show on tablet down always*/\n  @media (max-width: ', ') {\n    opacity: 1;\n  }\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      opacity: 1;\n    '], ['\n      opacity: 1;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      opacity: 1;\n\n      svg path {\n        fill: ', ';\n        stroke: ', ';\n      }\n    '], ['\n      opacity: 1;\n\n      svg path {\n        fill: ', ';\n        stroke: ', ';\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  margin-right: 5px;\n'], ['\n  color: ', ';\n  margin-right: 5px;\n']);

import styled, { css } from 'styled-components';

export var StyledBtn = styled.button(_templateObject, function (props) {
  return props.theme.tabletWidth;
}, function (_ref) {
  var productPage = _ref.productPage;
  return productPage && css(_templateObject2);
}, function (_ref2) {
  var isWishlistProduct = _ref2.isWishlistProduct,
      theme = _ref2.theme;
  return isWishlistProduct && css(_templateObject3, theme.dormifyPink, theme.dormifyPink);
});

export var StyledFaveCount = styled.span(_templateObject4, function (props) {
  return props.theme.dormifyBoulder;
});